import { gql } from '@apollo/client';

export const SEARCH_ORDERS_BY_ORDER_NUMBER = gql`
  query searchOrders($orderNumber: String) {
    searchOrders(searchOrdersInput: { orderNumber: $orderNumber }) {
      orders {
        id
        orderNumber
      }
    }
  }
`;
